module.exports = __webpack_public_path__ + "static/media/BS_F_Embroidery_Bicocca_Black_White.c01f605f.png";